import { action, computed, observable, makeObservable } from "mobx";
import Organization from "models/Organization";

export type TenantKind = "unresolved" | "authcx" | "tenant";

type OrgChangeCallback = (newOrg?: Organization) => void;

export class OrgSelectorComponentStore {
    @observable orgId?: string;
    @observable isLoading: boolean;
    @observable showOrgSelect: boolean = true;
    @observable orgError?: string;
    @observable.ref organization?: Organization;

    // Derive identity from the selection so unresolved and non-Authcx remain distinct.
    @computed get tenantKind(): TenantKind {
        if (!this.organization) return "unresolved";
        return this.organization.name === "Authcx" ? "authcx" : "tenant";
    }

    @computed get isAuthcxTenant(): boolean {
        return this.tenantKind === "authcx";
    }

    // get callback before changing the observable org to a different org so you can
    // do any org-change cleanup before org-based reactions trigger
    constructor(private orgChangeCallback?: OrgChangeCallback) {
        makeObservable(this);
    }

    @action
    selectOrg = (newOrg?: Organization) => {
        if (this.orgId !== newOrg?.id) {
            this.orgChangeCallback?.(newOrg);
            this.orgId = newOrg?.id;
            this.organization = newOrg;
        }
    };

    @action
    setOrgError = (error?: string) => {
        this.orgError = error;
    };

    @action
    setShowOrgSelect = (newValue: boolean) => {
        this.showOrgSelect = newValue;
    };

    @action
    setIsLoading = (newValue: boolean) => {
        this.isLoading = newValue;
    };
}
